import { DroneStatusType } from "@src/core/features";
import { DronesPageCollapseStatus } from "@src/features/drone/utils/operational-drones";

export interface ToggleCollapseViewProps {
  status: DronesPageCollapseStatus;
  children: React.ReactNode;
  count?: number;
}

export const DroneStatusColors: Record<DronesPageCollapseStatus, string> = {
  [DroneStatusType.IDLE]: 'success.main',
  [DroneStatusType.MISSION]: 'info.main',
  [DroneStatusType.UPDATE_SOFTWARE_REQUIRED]: '#CE3135',
};

export const DroneStatusNames: Record<DronesPageCollapseStatus, string> = {
  [DroneStatusType.IDLE]: 'IDLE',
  [DroneStatusType.MISSION]: 'MISSION',
  [DroneStatusType.UPDATE_SOFTWARE_REQUIRED]: 'UPDATE REQUIRED',
};
